import { DefaultMenuCategoryNameTranslator as n } from "./index2.js";
const r = "sitebrand";
function s(t) {
  const e = { siteBrand: t[r] ?? "" };
  return new n(e);
}
export {
  s as createMenuCategoryNameTranslator
};
//# sourceMappingURL=index.js.map
